import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ChatPage from "@/pages/ChatPage";
import AdminDashboard from "@/pages/AdminDashboard";
import EmbedChatPage from "@/pages/EmbedChatPage";

function App() {
  return (
    <div className="App min-h-screen bg-[#f1f2f2]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ChatPage />} />
          <Route path="/embed" element={<EmbedChatPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
